import { edmCampaign } from '@bingads-webui/edm-campaign';
import { modelToViewModelForAdGroup } from './ad-group';
import { modelToViewModelForAdGroupBudget } from './ad-group-for-budget';

export const readAdGroup = (cid, aid, campaignId, adGroupId) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .AdGroups.$withKey(adGroupId)
    .get()
    .toPromise();

export const loadAdGroup = (cid, aid, campaignId, adGroupId) =>
  readAdGroup(cid, aid, campaignId, adGroupId)
    .then((result) => {
      const data = modelToViewModelForAdGroup(result);

      return data;
    });

export const loadAdGroupForBudget = (cid, aid, campaignId, adGroupId, i18n) =>
  readAdGroup(cid, aid, campaignId, adGroupId)
    .then((result) => {
      const data = modelToViewModelForAdGroupBudget(result, i18n);

      return data;
    });
